import type { LostCorridorDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import { Alert, AlertDescription } from "@babackapp/ui/components/alert";
import { AlertTriangle } from "lucide-react";
import { countryFromISO } from "@/utils/country";

const MAX_DISPLAYED_CORRIDORS = 8;

export function PricingCoverageWarning({
  lostCorridors,
}: {
  lostCorridors: LostCorridorDto[];
}) {
  const t = useTranslation();

  if (lostCorridors.length === 0) return null;

  const displayed = lostCorridors.slice(0, MAX_DISPLAYED_CORRIDORS);
  const remaining = lostCorridors.length - displayed.length;

  return (
    <Alert variant="warning">
      <AlertTriangle className="h-4 w-4" />
      <AlertDescription className="text-xs space-y-1">
        <p>{t("settings.carriers.returnFeeOverride.coverageLossWarning")}</p>
        <ul className="list-disc pl-4">
          {displayed.map(({ origin, destination }) => (
            <li key={`${origin}-${destination}`}>
              {countryFromISO(origin)} → {countryFromISO(destination)}
            </li>
          ))}
        </ul>
        {remaining > 0 && (
          <p>
            {t("settings.carriers.returnFeeOverride.coverageLossMore", {
              count: remaining,
            })}
          </p>
        )}
      </AlertDescription>
    </Alert>
  );
}
